import React, {useEffect, useRef, useState} from 'react';
import Card from "../../../components/card";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import TemplateDefault from "../../../components/template-default";
import InputDateTime from "../../../components/input-datetime";
import {FaList, FaPrint} from "react-icons/fa";
import Button from "../../../components/button";
import reportService from "../../../services/report-service";
import {toast} from "react-toastify";
import {AlertMessage} from "../../../utils/alert-message";
import moment from "moment";
import {print} from "../components/print";
import "../report.css";
import {useQuery} from "@tanstack/react-query";
import projectService from "../../../services/project-service";
import SelectComponent from "../../../components/select-component";

const initialFilters = {
    init: moment().startOf('month').toDate(),
    end: moment().endOf('month').toDate(),
    project: []
}

const OsProduct = () => {
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState(initialFilters);
    const [filtersStr, setFiltersStr] = useState("");
    const handleInput = (value, name) => setFilters(prev => ({...prev, [name]: value}));
    const handleSelect = (id, value) => setFilters(prev => ({...prev, [id]: value}));
    const [pinnedBottomValues, setPinnedBottomValues] = useState({count: "TOTAL DE ORDENS DE SERVIÇO: 0"});

    useEffect(() => {
        document.title = "SISTEMA INTERNO";
    }, []);

    const [columnDefs] = useState([
        {field: "project", headerName: "Projeto", flex: 1, minWidth: 250},
        {field: "place", headerName: "Produto", flex: 1, minWidth: 250},
        {field: "count", headerName: "Total de ordens de serviço", flex: 1, minWidth: 250},
    ]);

    const gridRef = useRef();

    const formatDate = date => {
        if (date) return date.toLocaleDateString() + " " + date.toLocaleTimeString();

        return "";
    }

    const {data: projects} = useQuery({
        queryFn: () => projectService.options().then(({data}) => data),
        queryKey: ["projects"]
    });

    useEffect(() => {
        let count = 0;
        for (let item of data) {
            count += parseInt(item.count);
        }

        setPinnedBottomValues({count: `TOTAL DE ORDENS DE SERVIÇO: ${count}`})
    }, [data]);

    const apply = () => {
        const init = formatDate(filters.init);
        const end = formatDate(filters.end);
        const formData = new FormData();

        formData.append("init", init);
        formData.append("end", end);
        formData.append("project", filters.project.length > 0 ? JSON.stringify(filters.project.map(p => p.value)) : "");

        const filtersStr = `Início: ${init} - Fim: ${end}`;
        setFiltersStr(filtersStr);

        reportService.osProduct(formData)
            .then(({data}) => setData(data))
            .catch((err) => {
                const {data: {message}} = err.response;
                toast.error(AlertMessage[message] ?? "Não foi possível prosseguir.");
            });
    }

    const handlePrint = () => {
        if (gridRef.current) {
            const title = `RELATÓRIO DE ORDENS DE SERVIÇO POR PRODUTO`;
            const footer = `<tr><td colspan='2'></td><td>${pinnedBottomValues.count}</td></tr>`
            print(gridRef, columnDefs, title, filtersStr, footer);
        }
    }

    return (
        <TemplateDefault title="Relatório de ordens de serviço por produto" style={{height: "calc(100vh - 159px)"}}>
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <div className={"col-span-2"}>
                        <InputDateTime id={"date-init"} name={"init"} label={"Inicio"} selected={filters.init}
                                       onChange={(value) => handleInput(value, "init")}/>
                    </div>
                    <div className={"col-span-2"}>
                        <InputDateTime id={"date-end"} name={"end"} label={"Fim"} selected={filters.end}
                                       onChange={(value) => handleInput(value, "end")}/>
                    </div>
                    <div className="col-span-4 text-gray-900">
                        <SelectComponent
                            isMulti
                            instanceId="projects"
                            label="Projeto"
                            options={projects ?? []}
                            value={filters.project}
                            onChange={(value) => handleSelect("project", value)}
                            name="projects"
                        />
                    </div>
                    <div className={"hidden lg:block col-span-2"}></div>
                    <Button col={"col-span-1"} onClick={apply}>
                        <FaList/> <span className={"ml-1"}>Aplicar</span>
                    </Button>
                    <Button col={"col-span-1"} onClick={handlePrint}>
                        <FaPrint/>
                    </Button>

                </div>
                <div className={"ag-theme-quartz grid mt-4 report-table"}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={data}
                        columnDefs={columnDefs}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        gridOptions={{localeText: LocalizationAgGrid}}
                        domLayout='autoHeight'
                        pinnedBottomRowData={[pinnedBottomValues]}
                        getRowStyle={(params) => {
                            if (params.node.rowPinned) {
                                return {pointerEvents: "none", fontWeight: "700"};
                            }
                        }}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default OsProduct;